"use client";
import React from "react";
import Image from "next/image";
import Images from "@/app/assets/assets";
import type { StaticImageData } from "next/image";

type Member = {
  src: StaticImageData | string;
  name: string;
  role: string;
};

const members: Member[] = [
  { src: Images?.user1, name: "Alex Carter", role: "Engineering" },
  { src: Images?.user2, name: "Priya Sharma", role: "Design" },
  { src: Images?.user3, name: "Liam Nguyen", role: "Product" },
  { src: Images?.user4, name: "Sara Khan", role: "Marketing" },
];

export default function OutstandingMembersCard() {
  return (
    <div className="w-full flex items-center gap-[30px]">
      <div className="flex items-center">
        {members?.map((member) => (
          <div
            key={member.name}
            className={`relative h-[52px] w-[52px] sm:h-[56px] sm:w-[56px] rounded-full overflow-hidden ring-2 ring-white shadow -ml-3 first:ml-0`}
          >
            <Image
              src={member.src}
              alt={member.name}
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 100vw, 50vw"
            />
          </div>
        ))}
        <div className="relative h-[52px] w-[52px] sm:h-[56px] sm:w-[56px] rounded-full -ml-3 flex items-center justify-center bg-[#2F64F5] text-white font-semibold">
          <span className="text-sm sm:text-base leading-none">150+</span>
        </div>
      </div>
      <div className="text-[#636364] text-base md:text-lg font-medium">
        Outstanding Members
      </div>
    </div>
  );
}
